
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/pizza",
      function () {
        return require("private-next-pages/page/pizza.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/pizza"])
      });
    }
  